import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormWithProvider from 'components/forms/form/Form';
import FormFieldset from 'components/forms/form/FormFieldset';
import SectionHeader from 'components/sectionHeader/SectionHeader';
import useFetchAllPropertiesCalendarTools from '../../useFetchAllPropertiesCalendarTools';
import { CalendarImportSectionContainer } from './CalendarImportSection.styles';
import CalendarImportFields from './CalendarImportFields';
import { calendarImportFormSchema } from './CalendarImportForm.schema';
import {
  formDefaultValues,
  useCalendarImportFormSubmit,
} from './useCalendarImportFormSubmit';
import CalendarImportTable from './table/CalendarImportTable';
import useFetchIcals from './useFetchIcals';

const CalendarImportSection = () => {
  const [propertyUid, setPropertyUid] = useState<string>('');
  const { t } = useTranslation();
  const { allProperties, isFetchingProperties } =
    useFetchAllPropertiesCalendarTools();
  const { data: icals, isFetching: isFetchingIcals } = useFetchIcals(
    propertyUid,
    allProperties || [],
  );
  const onSubmit = useCalendarImportFormSubmit({ allProperties });

  return (
    <CalendarImportSectionContainer data-testid="calendar-import-section">
      <SectionHeader
        id="calendar-import-sync"
        title={t('pageAutomations.calendarTools.calendarImportSection.title')}
        subtitle={t(
          'pageAutomations.calendarTools.calendarImportSection.description',
        )}
      />
      <FormWithProvider
        horizontal
        onSubmit={onSubmit}
        schema={calendarImportFormSchema()}
        defaultValues={formDefaultValues}
      >
        <FormFieldset>
          <CalendarImportFields
            isFetchingProperties={isFetchingProperties}
            allProperties={allProperties || []}
            setPropertyUid={setPropertyUid}
          />
        </FormFieldset>
      </FormWithProvider>

      {((propertyUid && icals && icals.length > 0) || isFetchingIcals) && (
        <CalendarImportTable icals={icals || []} isLoading={isFetchingIcals} />
      )}
    </CalendarImportSectionContainer>
  );
};

export default CalendarImportSection;
